<div class="app-topnav-content">
  <mat-toolbar color="primary" class="lns-toolbar">
    <span class="home-link" [routerLink]="['/']"
      ><img src="./assets/images/logo-leonus.png"
    /></span>

    <div class="lns-navbar">
      <mat-nav-list>
        <a
          class="lns-nav-link"
          [routerLink]="['/users']"
          *ngIf="showNavLink(userCanRead)"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "users.users" | translate }}
          </span>
        </a>
        <a
          class="lns-nav-link"
          [routerLink]="['/clients']"
          *ngIf="showNavLink(clientCanRead)"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "clients.clients" | translate }}
          </span>
        </a>
        <a
          class="lns-nav-link"
          [routerLink]="['/staffs']"
          *ngIf="showNavLink(deviceCanRead)"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "staffs.staffs" | translate }}
          </span>
        </a>
        <a
          class="lns-nav-link"
          [routerLink]="['/roles']"
          *ngIf="showNavLink(roleCanRead)"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "roles.roles" | translate }}
          </span>
        </a>
        <a
          class="lns-nav-link"
          [routerLink]="['/locations']"
          *ngIf="showNavLink(locationCanRead)"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "locations.locations" | translate }}
          </span>
        </a>

        <a
          class="lns-nav-link"
          [matMenuTriggerFor]="messages"
          *ngIf="showNavLink()"
          routerLinkActive="active"
        >
          <span
            class="nav-link-title"
            [class]="childrenMessageActive ? 'lns-messages-active ' : ''"
          >
            {{ "messages.messages" | translate }}
          </span>
        </a>
        <mat-menu #messages="matMenu">
          <a
            mat-menu-item
            [routerLink]="['/messages/direct']"
            routerLinkActive="active"
          >
            {{ "directMessages.title" | translate }}
          </a>
          <a
            mat-menu-item
            [routerLink]="['/messages/promotional']"
            routerLinkActive="active"
          >
            {{ "announcementAndPromotionalMessages.headTitle" | translate }}
          </a>
          <a
            mat-menu-item
            [routerLink]="['/messages/predefined']"
            [routerLinkActive]="['active']"
          >
            {{ "polls.title" | translate }}
          </a>
        </mat-menu>
        <a
          class="lns-nav-link"
          [routerLink]="['/translations']"
          *ngIf="showNavLink()"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "translations.translations" | translate }}
          </span>
        </a>
        <a
          class="lns-nav-link"
          [matMenuTriggerFor]="auditLogs"
          *ngIf="showNavLink()"
          routerLinkActive="active"
        >
          <span
            class="nav-link-title"
            [class]="childrenAuditLogsActive ? 'lns-audit-log-active ' : ''"
          >
            {{ "auditLogs.auditLogs" | translate }}
          </span>
        </a>
        <mat-menu #auditLogs="matMenu">
          <a
            mat-menu-item
            [routerLink]="['/audit-logs/mobile']"
            routerLinkActive="active"
          >
            {{ "auditLogs.mobile" | translate }}
          </a>
          <a
            mat-menu-item
            [routerLink]="['/audit-logs/ib']"
            routerLinkActive="active"
          >
            {{ "auditLogs.ib" | translate }}
          </a>
        </mat-menu>
        <a
          class="lns-nav-link"
          [routerLink]="['/property']"
          *ngIf="showNavLink()"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "property.property" | translate }}
          </span>
        </a>

        <a
          class="lns-nav-link"
          [routerLink]="['/changelogs']"
          *ngIf="showNavLink()"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "changelogs.changelogs" | translate }}
          </span>
        </a>
        <!-- <a
          class="lns-nav-link"
          [routerLink]="['/tokens']"
          *ngIf="showNavLink(tokenCanRead)"
          routerLinkActive="active"
        >
          <span class="nav-link-title">
            {{ "token.title" | translate }}
          </span>
        </a> -->
      </mat-nav-list>
    </div>

    <span class="space"></span>
    <span class="lns-username-span"
      >Welcome, <span class="lns-username">{{ username }}</span></span
    >
    <button mat-button [matMenuTriggerFor]="language">
      <img
        src="../../../../assets/images/language-1.png"
        class="lns-language"
      />
    </button>
    <mat-menu #language="matMenu">
      <button mat-menu-item>
        {{ "language." + (languages?.data)[0].code | lowercase | translate }}
      </button>
    </mat-menu>
    <button mat-button [matMenuTriggerFor]="account" *ngIf="showNavLink()">
      <mat-icon class="lns-logout">account_circle</mat-icon>
    </button>
    <mat-menu #account="matMenu">
      <button mat-menu-item *ngIf="showNavLink()" (click)="logout()">
        {{ "general.logout" | translate }}
      </button>
      <button
        mat-menu-item
        *ngIf="showNavLink()"
        [routerLink]="['/change-password']"
      >
        {{ "changePassword.title" | translate }}
      </button>
    </mat-menu>
  </mat-toolbar>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
